'use strict';

module.exports = require('wix-ui-icons-common/Search.js');


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-style-react/dist/src/new-icons/Search.js
// module id = 1370
// module chunks = 0